import axios from 'axios'
import { ElMessage } from 'element-ui'

const instance = axios.create({
   baseURL: 'https://mem.bossbolo.com/memberApi/',
 //baseURL:"http://127.0.0.1:8089/",
  timeout: 10000
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    config.headers.token = localStorage.getItem('token')
    return config
  }
)

// 响应拦截器
instance.interceptors.response.use(
  res => {
    console.log(res.status)
    if (res.status === 200) {
      return res.data
    } else if (res.status === 401) {
      ElMessage.error('登录过期')
      return "登录失败";
    }
  }
)
export default instance
